export enum Schema {
    String = 'string',
    Number = 'number',
    Boolean = 'boolean',
    Moment = 'moment',
    Auto = 'auto',
}
